import { useEffect } from 'react';

import { DEFAULT_SEARCH_BILLS_DATA } from '@app/pages/PaymentDocuments/components/PaymentDocumentsRegistry/data';
import type { UsePaymentDocumentsEffectsProps } from '@app/pages/PaymentDocuments/components/PaymentDocumentsRegistry/types';

export const usePaymentDocumentsRegistryEffects = ({
  handleSearchFilters,
  handleSearchData,
}: UsePaymentDocumentsEffectsProps) => {
  useEffect(() => {
    handleSearchFilters();
  }, [handleSearchFilters]);

  useEffect(() => {
    handleSearchData(DEFAULT_SEARCH_BILLS_DATA);
  }, [handleSearchData]);
};
